export default "__VITE_ASSET__DeuuPRyL__"